<div class="modal-header">
  <h4 class="modal-title">{{ 'commentContractModal.modalHeader.title' | translate }}</h4>
  <button type="button" class="close" (click)="closeModal()">{{ 'commentContractModal.modalHeader.closeButton' | translate }}</button>
</div>

<div class="modal-body">
  <div *ngFor="let comment of comments; let i = index" class="comment-section">
    <div class="week-header">
      {{ 'commentContractModal.weekHeader' | translate }} {{ comment.date_wednesday | date:'dd/MM/yyyy' }}
    </div>
    <div style="display: contents">
      <textarea id="comment-{{i}}"
                class="form-control"
                [(ngModel)]="comments[i].commentaires"
                (change)="updateComment(comment.id_week, comments[i].commentaires)"
                rows="3">
      </textarea>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="closeModal()">{{ 'commentContractModal.closeButton' | translate }}</button>
</div>
